import React, { useMemo } from "react";
import DOMPurify from "dompurify";

const HtmlContent = ({ html, className }) => {
    const clean = useMemo(() => DOMPurify.sanitize(html || ""), [html]);
    return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
};

export default HtmlContent;